var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.time,
          expression: "time",
        },
      ],
      staticClass: "time-field",
      class: _vm.errorMessages.length ? "is_error" : "",
      attrs: {
        type: "time",
        step: _vm.step,
        disabled: _vm.loading || _vm.disabled,
      },
      domProps: { value: _vm.time },
      on: {
        input: [
          function ($event) {
            if ($event.target.composing) return
            _vm.time = $event.target.value
          },
          _vm.handleInput,
        ],
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }